import type { JSX } from 'react';

import { VisibilityIcon } from '@change/ds-icons';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useTrackBannerActionClick, useTrackBannerView } from '../hooks/useTrackingStarterDashboard';

export type BannerProps = {
	location: 'home' | 'petition';
	bannerContext: { petitionId: string; petitionSlug: string };
};

export function StarterDashPromptingBanner({
	location,
	bannerContext: { petitionId, petitionSlug },
}: BannerProps): JSX.Element | null {
	const trackClick = useTrackBannerActionClick(location, petitionId);
	useTrackBannerView(location, petitionId);

	return (
		<div className="bg-fill-accent-secondary-strong" data-testid="dash-prompt-banner">
			<div className="flex flex-col items-center justify-start px-4 py-4 md:flex-row md:justify-between md:px-10 md:py-2">
				<div className="mb-4 flex items-center md:mb-0 md:mr-4">
					<VisibilityIcon size="medium" className="mr-4 text-white" />
					<span className="flex text-white">
						<Translate value="corgi.components.banner.starter_dashboard_prompt.text_alt_2" />
					</span>
				</div>
				<Button
					as="a"
					data-testid="dash-prompt-redirect-button"
					href={`/p/${petitionSlug}/dashboard`}
					onClick={trackClick}
					variant="secondary-solid"
					size="small"
					className="w-full md:w-[300px]"
				>
					<Translate value="corgi.components.banner.starter_dashboard_prompt.cta_btn_text" />
				</Button>
			</div>
		</div>
	);
}
